import React, {Fragment, PureComponent, ReactNode, StrictMode} from "react";
import {CheckIcon} from "@App/Components/common/Icons";
import {Transition} from "@headlessui/react";


type StepProps = {
    title: string
    subtitle?: string
    completedTitle: string
    children: any
    id?: number
    open?: boolean
    completed?: boolean
    last?: boolean
    onBackToStep?: () => void
    completedGoBackLinkTitle?: string
}

export class Step extends PureComponent<StepProps> {

    render(): ReactNode {
        const {
            title,
            subtitle,
            completedTitle,
            children,
            id,
            open,
            completed,
            last,
            onBackToStep,
            completedGoBackLinkTitle
        } = this.props

        return (
            <StrictMode>
                <div className={`flex ${!open ? 'overflow-hidden' : ''}`}>
                    <div className="flex flex-col">
                        <div
                            className={`transition-all duration-400 ease-in-out shrink-0 w-8 h-8 rounded-full flex items-center justify-center mr-4 text-white text-xl font-serif font-bold ${completed ? "bg-neutral-100 text-neutral-500" : "bg-primary"}`}>{completed ?
                            <CheckIcon/> : id + 1}</div>
                        <div
                            className={`w-[1px] bg-neutral-100 ml-4 h-full min-h-[1.5rem] ${last ? "opacity-0" : ""}`}/>
                    </div>
                    <div className="flex flex-col ml-3 w-full md:mb-10">
                        <div className="mt-1">
                            {!completed && (
                                title
                            )}
                            {completed && (
                                <Fragment>
                                    {completedTitle}
                                    {completedGoBackLinkTitle && (
                                        <span className="font-bold text-primary underline cursor-pointer"
                                              onClick={onBackToStep}
                                              dangerouslySetInnerHTML={{__html: completedGoBackLinkTitle}}/>
                                    )}
                                    {completed && (
                                        <div className={"text-sm text-neutral-500"}>
                                            {subtitle}
                                        </div>
                                    )}
                                </Fragment>
                            )}
                        </div>
                        <Transition
                            appear={true}
                            show={open}
                            enter={"transition transform duration-100 ease-out"}
                            enterFrom={"translate-y-4 opacity-0"}
                            enterTo={"translate-y-0 opacity-100 contents"}
                            leave={"transition transform duration-100 ease-in"}
                            leaveFrom={"opacity-100"}
                            leaveTo={"opacity-0 -translate-y-4"}>
                            {children}
                        </Transition>
                    </div>
                </div>
            </StrictMode>
        );
    }
}
